<template>
    <div class="col-lg-4 col-12 col-md-6 card-col">
        <div class="card-ct doughnut-chart-ct card-rounded-shadowed">
            <h3 class="text-center">{{$t('chart_card_total_materials')}}</h3>

            <div class="doughnut-chart">
                <div class="total-amount-ct">
                    <div class="total-amount">
                        <div class="kg">{{this.totalWeight}} <small>{{$t('amount_kg')}}</small></div>
                        <div class="gab">{{this.totalPieces}} <small>{{$t('amount_pieces')}}</small></div>
                    </div>
                </div>
                <doughnut :data="chartData" :width="100" :height="140"></doughnut>
            </div>
        </div>
    </div>
</template>

<script>

import Doughnut from '../Charts/DoughnutChart';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    Doughnut,
  },
  props: ["data"],
  data () {
    return {
      chartData: {},
      totalWeight: 0,
      totalPieces: 0,
    }
  },
  computed: {
    ...mapGetters('Translations', ['language']),
  },
  watch: {
    data: function (value, oldValue) {
      if (value) {
        this.getChartData();
      }
    },
    language: function (value, oldValue) {
      this.getChartData();
    }
  },
  methods: {
    getChartData() {
      // this is where you get the relevant data for the chart
      let newData = {
        labels: [],
        datasets: [{
          data: [],
          backgroundColor: [],
          hoverBackgroundColor: [],
          borderColor: 'rgba(255,255,255,1)',
          hoverBorderColor: 'rgba(255,255,255,1)',
          borderWidth: 2,
        }]
      }
      let totalWeight = Number(this.totalWeight);
      let totalPieces = this.totalPieces;
      if (this.data) {
        this.data.forEach((item, i) => {
          newData.labels.push(this.$t(item.title));
          newData.datasets[0].data.push(item.count)
          newData.datasets[0].backgroundColor.push(item.color);
          newData.datasets[0].hoverBackgroundColor.push(item.color);
          totalWeight += Number(item.weight);
          totalPieces += item.count;
        });
        Vue.set(this, 'chartData', newData);
        Vue.set(this, 'totalWeight', (Math.round(totalWeight * 100) / 100));
        Vue.set(this, 'totalPieces', totalPieces);
      }
    },
  },
}
</script>

<style scoped>
</style>